import { saveAs } from 'file-saver';
import { createPythonBlob } from '.';

export const downloadPythonFile = (pythonCode: string, fileName: string) => {
  saveAs(createPythonBlob(pythonCode), fileName);
};
